export const env = {
    siteUrl: process.env.REACT_APP_MAIN_SITE_URL,
    apiUrl: process.env.REACT_APP_API_URL,
    paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    apiKey: process.env.REACT_APP_API_KEY
}